export default {
  showPhysicians: false,
  allowPhysicianRegistration: false,
  showRealtors: false,
  launchDarklyClientId: '69988716f1cbe00b0679bcab',
}
